import { AutoMap } from "@automapper/classes"
import { MPCA } from "./mpca";

export class ProcessTechnique {
    @AutoMap()
    ScolaTechnique!: string;
    @AutoMap()
    Humidification!: string;
    @AutoMap()
    HumidityWork!: string;
    @AutoMap()
    Catchment!: string;
    @AutoMap()
    Mpca!: MPCA;

    public constructor(init?: Partial<ProcessTechnique>) {
        Object.assign(this, init);
    }
}